import { LogoSunmaxx } from './LogoSunmaxx'

export default LogoSunmaxx
